import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDepartment as apiCreateDepartment } from "../../api/apiDepartments";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

/**
 * Hook لإنشاء قسم جديد
 */
export function useCreateDepartment() {
    const queryClient = useQueryClient();

    const {
        mutate: createDepartment,
        isPending: isCreating,
        error,
    } = useMutation({
        mutationFn: (data) => apiCreateDepartment(data),
        onSuccess: (response) => {
            toast.success(response.message || 'Department created successfully');
            queryClient.invalidateQueries({
                queryKey: ["departments"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Failed to create department");
            toast.error(msg);
        },
    });

    return { createDepartment, isCreating, error };
}
